import React, { useCallback, useContext, useMemo } from 'react';
import classNames from 'classnames';
import LeadsContext from '../../../../providers/Leads';
import ListingContext from '../../../../providers/Listing/Listing.context';
import MemberFileAccessSelector from 'router/subrouters/DataRoom/components/MemberFileAccessSelector';
import { useTranslation } from 'react-i18next';
import WithdrawnLeadsFileAccessSnapshot from './components/WithdrawnLeadsFileAccessSnapshot';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

import './LeadFiles.styles.scss';
import './LeadFiles.styles.responsive.scss';

type LeadFilesProps = {
  className?: string;
};

const LeadFiles: React.FC<LeadFilesProps> = (props) => {
  const { className } = props;

  const { selectedLead: lead, updateLead } = useContext(LeadsContext);

  const { canManageDataRoom, dataRoomMemberId, withdrawnInterest } = lead || {};

  const {
    canAccessDataRoom,
    areActionsDisabled,
    dealRoom: { dataRoomId },
  } = useContext(ListingContext);

  const { t } = useTranslation();

  const classes = classNames('lead-files', className);

  const updateMember = useCallback(
    (member: DataRoomMember) => {
      updateLead({
        ...lead,
        numberOfAccessableDocuments: member.accessableDataRoomNodesView.length,
      });
    },
    [lead, updateLead],
  );

  const Content = useMemo(() => {
    if (!dataRoomMemberId) {
      if (withdrawnInterest) {
        return <WithdrawnLeadsFileAccessSnapshot />;
      }

      return <div className="white-panel">{t('leadIsNotDataRoomMember')}</div>;
    }

    if (!canManageDataRoom || !canAccessDataRoom) {
      return (
        <div className="white-panel">
          {t('youDontHavePermissionToChangeLeadFileAccess')}
        </div>
      );
    }

    return (
      <MemberFileAccessSelector
        defaultOpen
        dataRoomId={dataRoomId}
        dataRoomMemberId={dataRoomMemberId}
        isDisabled={areActionsDisabled}
        updateMember={updateMember}
      />
    );
  }, [
    areActionsDisabled,
    canAccessDataRoom,
    canManageDataRoom,
    dataRoomId,
    dataRoomMemberId,
    withdrawnInterest,
    t,
    updateMember,
  ]);

  return <div className={classes}>{Content}</div>;
};

export default LeadFiles;
